<template>
  <div class="navbar">
    <router-link to="/" class="brand">
      <img class="logo" src="../assets/logo/firex-logo.jpeg" alt="FireX Logo" />
      <div class="brand-name">Fire<span>X</span></div>
    </router-link>

    <nav class="nav-links">
      <router-link to="/" class="nav-link">Home</router-link>
      <router-link to="/Services" class="nav-link">Services</router-link>
      <router-link to="/about-us" class="nav-link">About</router-link>
      <router-link :to="{ path: '/', hash: '#contact' }" class="nav-link">Contact</router-link>
    </nav>

    <a href="tel:7605673777" class="cta-phone">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
      760-567-3777
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    open() {
      this.$emit("showQuote", true);
    }
  }
};
</script>

<style scoped>
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  padding: 0 2rem;
  background: rgba(10, 10, 10, 0.85);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--color-border);
}

@media screen and (max-width: 900px) {
  .navbar {
    display: none;
  }
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
}

.logo {
  height: 44px;
  border-radius: 8px;
}

.brand-name {
  font-family: var(--font-display);
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-text);
  letter-spacing: -0.02em;
}

.brand-name span {
  color: var(--color-fire);
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-link {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-text-muted);
  text-decoration: none;
  transition: color 0.2s;
  letter-spacing: 0.01em;
}

.nav-link:hover,
.nav-link.router-link-exact-active {
  color: var(--color-text);
}

.cta-phone {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--color-fire);
  color: white;
  font-weight: 600;
  font-size: 0.875rem;
  padding: 0.5rem 1.25rem;
  border-radius: 4px;
  text-decoration: none;
  transition: background 0.2s, transform 0.15s;
}

.cta-phone:hover {
  background: var(--color-fire-light);
  transform: translateY(-1px);
}
</style>
